export const queryPath = (game, query) => `/games/queries?game_id=${game.getID()}&query_id=${query.getID()}`

export const createQueryPath = game => `/games/queries/create?game_id=${game.getID()}`

export const listQueriesPath = game => `/games/queries?game_id=${game.getID()}`

export const listQueryRequestRecordsPath = game => `/games/query_request_records?game_id=${game.getID()}`

export const listDiscardedLogsPath = game => `/games/discarded_logs?game_id=${game.getID()}`
